export default __webpack_public_path__ + "static/media/high.7c401c7a.png";